import { useState, useEffect } from "react";
import throttle from "lodash.throttle";

// Devuelve true cuando la página se scrolleó más de `threshold` píxeles.
// Se usa para que el header pase de transparente (sobre el video del hero) a
// sólido una vez que el contenido queda debajo.
export default function usePageScrolled(threshold = 80) {
  const [scrolled, setScrolled] = useState(
    () => typeof window !== "undefined" && window.scrollY > threshold
  );

  useEffect(() => {
    const handleScroll = throttle(() => {
      setScrolled(window.scrollY > threshold);
    }, 100);

    window.addEventListener("scroll", handleScroll, { passive: true });

    handleScroll();

    return () => {
      handleScroll.cancel();
      window.removeEventListener("scroll", handleScroll);
    };
  }, [threshold]);

  return scrolled;
}
